<template>
  <div :class="['row', border ? 'row-border' : '']">
    <p class="row-label">{{ label }}</p>
    <p class="row-value">{{ value }}</p>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: String,
    border: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.row {
  height: 70px;
  background-color: $color-white;
  @extend .flex-row;
  align-items: center;
  &-border {
    border-bottom: 1px solid $color-bg;
  }
  &-label {
    width: 160px;
    padding-left: 24px;
    @include text(23px, 400, $color-grey);
  }
  &-value {
    flex: 1;
    text-align: right;
    padding-right: 24px;
    @include text(23px, 600, #000000);
  }
}
</style>